<template>
    <div class="card">
        <slot></slot>
    </div>
</template>

<style>
.card{
  padding: 1rem;
  background: #e1fcdc;
  border-radius: 10px;
}

.card b{
  color: #385e31;
}
</style>